import React, { memo } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { styled, Theme } from '@material-ui/core';

import { theme } from '../../../infrastructure/theme';
import { colors } from '../../../infrastructure/newDesignTheme';
import { IconArrowFilled } from '../../icons';

import { Columns, SortDirection, SortingState } from '../nkCustomTable.types';

interface NkHeaderProps {
  columns: Columns;
  onChangeSorting: (sortKey: string) => () => void;
  sorting: SortingState;
  isSelectAll: boolean;
  onSelectAll: () => void;
  showSelection: boolean;
}

const NkHeader = ({
  columns,
  onChangeSorting,
  sorting,
  isSelectAll,
  onSelectAll,
  showSelection
}: NkHeaderProps) => {
  return (
    <thead>
      <tr>
        {showSelection && <StyledCheckboxTh>
          <Checkbox
            checked={isSelectAll}
            onChange={onSelectAll}
            color="primary"
          />
        </StyledCheckboxTh>}
        {columns.map((column) => {
          if (column.isHide) {
            return null;
          }
          return (
            <StyledTh
              $isSorted={Boolean(sorting[column.key])}
              onClick={onChangeSorting(column.key)}
              key={column.key}
            >
              {column.title}
              <StyledIconArrow
                $sortDirection={sorting[column.key]}
                color={theme.palette.text.primary}
              />
            </StyledTh>
          );
        })}
      </tr>
    </thead>
  );
};

export default memo(NkHeader);

interface StyledThProps {
  $isSorted?: boolean;
}
interface StyledIconArrowProps {
  $sortDirection: SortDirection;
}

const StyledTh = styled('th')<Theme, StyledThProps>(({ theme, $isSorted }) => ({
  padding: theme.spacing(2),
  textAlign: 'start',
  cursor: 'pointer',
  // TODO: change this to appropriate theme color once theming is done on app level
  backgroundColor: $isSorted ? colors.almostHuman : 'initial',
  '&:hover': {
    backgroundColor: colors.almostHuman,
  },
}));
const StyledCheckboxTh = styled('th')({
  width: 60,
});

const StyledIconArrow = styled(IconArrowFilled)<Theme, StyledIconArrowProps>(
  ({ theme, $sortDirection }) => ({
    margin: `0 ${theme.spacing()}px`,
    visibility: $sortDirection ? 'visible' : 'hidden',
    rotate: $sortDirection === SortDirection.ASC ? '180deg' : 'initial',
  }),
);
